import type { ButtonProps } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useFetchCreator } from '@/hooks/queries/use-fetch-creator';
import SendInvitationModal from './send-invitation-modal';

interface SendInvitationButtonProps extends ButtonProps {
  creatorId: string;
  onSuccess?: (success: boolean) => void;
  sourceRecommendationId?: string;
  children: React.ReactNode;
}

const SendInvitationButton: React.FC<SendInvitationButtonProps> = ({
  creatorId,
  onSuccess,
  sourceRecommendationId,
  children,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Fetch the full creator only once the user opens the invitation flow, not on
  // mount. This button often renders without ever being clicked (e.g. in the
  // mention preview), so an eager fetch would waste one request per render site.
  const { data: creator, isPending } = useFetchCreator(creatorId, { enabled: isOpen });

  const handleClose = ({ success }: { success?: boolean }) => {
    setIsOpen(false);
    if (success && onSuccess) {
      onSuccess(success);
    }
  };

  return (
    <>
      <Button onClick={() => setIsOpen(true)} {...props} loading={isOpen && isPending}>
        {children}
      </Button>
      {creator && (
        <SendInvitationModal
          isOpen={isOpen}
          onClose={handleClose}
          creator={creator}
          sourceRecommendationId={sourceRecommendationId}
        />
      )}
    </>
  );
};

export default SendInvitationButton;
